<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uqJnaL/tc-custom/9780062016751.jpg?1731166600073" alt="This image is the cover for the book Monk Downstairs, The Monk Downstairs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monk Downstairs, The Monk Downstairs
      </h1>
      <p class="bookDescription body article font2">
        <b>A cynical single mom’s life changes when she rents her apartment to an introverted ex-monk in this “tender, witty” novel (<i>New York Times Book Review</i>).</b><br/><br/>Rebecca Martin is a single mother with an apartment to rent and a sense that she has used up her illusions. <i>I had the romantic thing with my first husband, thank you very much</i>, she tells a hapless suitor. <i>I’m thirty-eight years old, and I’ve got a daughter learning to read and a job I don’t quite like. I don’t need the violin music</i>. But when the new tenant in her in-law apartment turns out to be Michael Christopher, on the lam after twenty years in a monastery and smack dab in the middle of a dark night of the soul, Rebecca begins to suspect that she is not as thoroughly disillusioned as she had thought.<br/><br/>Her daughter, Mary Martha, is delighted with the new arrival, as is Rebecca’s mother, Phoebe, a rollicking widow making a new life for herself among the spiritual eccentrics of the coastal town of Bolinas. Even Rebecca’s best friend, Bonnie, once a confirmed cynic in matters of the heart, urges Rebecca on. But none of them, Rebecca feels, understands how complicated and dangerous love actually is.<br/><br/>As her unlikely friendship with the ex-monk grows toward something deeper, and Michael wrestles with his despair while adjusting to a second career flipping hamburgers at McDonald’s, Rebecca struggles with her own temptation to hope. But it is not until she is brought up short by the realities of life and death that she begins to glimpse the real mystery of love, and the unfathomable depths of faith . . . <br/><br/><b>Praise for <i>The Monk Downstairs</i></b><br/><br/><b>A <i>New York Times</i> Notable Book of the Year</b><br/><br/><b>“Fluent prose, seamless dialogue and a lovingly rendered Bay Area setting lift this novel above the pack. . . . A charmingly written, gratifyingly hopeful tale.” —<i>Publishers Weekly</i></b><br/><br/><b>“This gentle, luminous love story shimmers with warmth, honesty, and self-deprecating humor.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tim Farrington
      </h2>
      
      <p class="authorDescription body article"><P>Tim Farrington is the author of <I>Lizzie's War</I>, <I>The Monk Downstairs</I>,&#8212;a New York Times Notable Book&#8212;and <I>The Monk Upstairs</I>, as well as the critically acclaimed novels <I>The California Book of the Dead</I> and <I>Blues for Hannah</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d1053e8